import { z } from "zod";
/*
 * Read-only catalogue views of the twin's own warehouse (the curated views
 * and connector projections authored products read from) for the Knowledge
 * page: the relations the organisation may see, one relation's columns and
 * a bounded row sample. Served by the control plane through its warehouse
 * broker, which applies the tenant gate and the organisation's access policy.
 */
const identifierSchema = z.string().trim().min(1).max(120);
export const warehouseRelationSchema = z
    .object({
    schema: identifierSchema,
    relation: identifierSchema,
    description: z.string().nullable(),
})
    .strict();
export const listWarehouseRelationsResponseSchema = z
    .object({
    relations: z.array(warehouseRelationSchema),
    truncated: z.boolean(),
})
    .strict();
export const warehouseColumnSchema = z
    .object({
    name: z.string().min(1),
    dataType: z.string().min(1),
    nullable: z.boolean(),
    description: z.string().nullable(),
})
    .strict();
export const describeWarehouseRelationResponseSchema = z
    .object({
    schema: identifierSchema,
    relation: identifierSchema,
    columns: z.array(warehouseColumnSchema),
})
    .strict();
export const sampleWarehouseRelationResponseSchema = z
    .object({
    schema: identifierSchema,
    relation: identifierSchema,
    columns: z.array(z.string()),
    rows: z.array(z.record(z.string(), z.unknown())),
    rowCount: z.number().int().nonnegative(),
    truncated: z.boolean(),
})
    .strict();
